(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["KV-video"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-kv-video-script')
  if (!window.kvVideo && $url && $url.dataset.designMode !== 'yes') {
    window.kvVideo = $url.value

    var $script = document.createElement('script')
    $script.src = window.kvVideo
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auto-cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-auto-cards-scroller-script')
    if (!window.autoCardsScroller && $url) {
      window.autoCardsScroller = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.autoCardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-image-group"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-before-after-image-group-script')
    if (!window.beforeAfterImageGroup && $url) {
      window.beforeAfterImageGroup = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.beforeAfterImageGroup
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-blog-posts-script')
  if (!window.blogPosts && $url && $url.dataset.designMode !== 'yes') {
    window.blogPosts = $url.value

    var $script = document.createElement('script')
    $script.src = window.blogPosts
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creativity-spot-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-spot-cards-script')
    if (!window.spotCards && $url) {
      window.spotCards = true

      var $script = document.createElement('script')
      $script.src = $url.value
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-screen-zoom-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-full-screen-zoom-text-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-spec-stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-image-stairs-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-v2-script')
    if (!window.imageSlidersV2 && $url && $url.dataset.designMode !== 'yes') {
      window.imageSlidersV2 = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSlidersV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-banner-script')
  if (!window.imageBanner && $url && $url.dataset.designMode !== 'yes') {
    window.imageBanner = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageBanner
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-kv-banner-script')
  if (!window.kvBanner && $url && $url.dataset.designMode !== 'yes') {
    window.kvBanner = $url.value

    var $script = document.createElement('script')
    $script.src = window.kvBanner
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-collection-product-grid-script')
    if ($url && $url.dataset.designMode !== 'yes') {
      var $script = document.createElement('script')
      $script.src = $url.value
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  try {
    function getCookie(c_name) {
      if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) {
            c_end = document.cookie.length;
          }
          return unescape(document.cookie.substring(c_start, c_end));
        }
      }
      return "";
    }

    ;(function() {
      var $enableShowOrNotABTest = document.getElementById('as-enable-exclusive-promotion-show-or-not-abtest');
      var AB_NUM_COOKIE = 'abtno';
      var abtno = getCookie(AB_NUM_COOKIE);
      var THRESHOLD = 500; // 50%

      var isTester = (abtno - 0 < THRESHOLD);

      if ($enableShowOrNotABTest != null) {
        if(isTester) {
          // 不显示
          var $exclusivePromotionV2 = document.querySelector('product-coupon');
          $exclusivePromotionV2 && $exclusivePromotionV2.remove();
        } else {
          // 显示
        }
      }
    })();
  } catch (error) {
    console.error('Error, error code: Exclusive promotion AB test');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone-horizontal"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-milestone-horizontal-script')
    if (!window.milestoneHorizontal && $url && $url.dataset.designMode !== 'yes') {
      window.milestoneHorizontal = $url.value

      var $script = document.createElement('script')
      $script.src = window.milestoneHorizontal
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-item-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-tab-script')
    if (!window.titleWithTab && $url) {
      window.titleWithTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.titleWithTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-scrolling-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-parallax-scrolling-cards-script')
    if (!window.ParallaxScrollingCards && $url) {
      window.ParallaxScrollingCards = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.ParallaxScrollingCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-compare-script')
    if (!window.productCompareScript && $url) {
      window.productCompareScript = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.productCompareScript
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-tab-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scenario-tab-cards-script')
    if (!window.scenarioTabCards && $url && $url.dataset.designMode !== 'yes') {
      window.scenarioTabCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.scenarioTabCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenarios"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scenarios-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-unlock-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scroll-unlock-cards-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tagline-with-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-tagline-with-text-script')
    if (!window._taglineWithText && $url && $url.dataset.designMode !== 'yes') {
      window._taglineWithText = $url.value
      var $script = document.createElement('script')
      $script.src = window._taglineWithText
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-variant-tab-script')
    if (!window.variantTab && $url) {
      window.variantTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.variantTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-tutorial"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-video-tutorial-script')
    if (!window.videoTutorial && $url && $url.dataset.designMode !== 'yes') {
      window.videoTutorial = $url.value

      var $script = document.createElement('script')
      $script.src = window.videoTutorial
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
